import { render } from "./OImportFile.vue?vue&type=template&id=18bd05ec&scoped=true"
import script from "./OImportFile.vue?vue&type=script&lang=js"
export * from "./OImportFile.vue?vue&type=script&lang=js"

import "./OImportFile.vue?vue&type=style&index=0&id=18bd05ec&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bd05ec"]])

export default __exports__